Ext.define('SA.model.AdHocNotice', {
    statics: {
        deserialize({type, user_notification_id: id, message}) {
            var isWarning = type === 'warning-notice',
                messageHtml = message;

            return new SA.model.AdHocNotice({id, messageHtml, isWarning});
        }
    },

    constructor({id, messageHtml, isWarning}) {
        this.id = id;
        this.messageHtml = messageHtml;
        this._isWarning = isWarning;
    },

    getMessageHtml() {
        return this.messageHtml;
    },

    isWarning() {
        return this._isWarning;
    },

    markViewed() {
        SA.model.Notices.acknowledge({id: this.id});
    }
});